<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>

    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun"
          >新增</Button
        ></template
      ></selectTool
    >
    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(260)"
    >
      <template slot-scope="{ row, index }" slot="icon">
        <img :src="'static/' + row.icon + '/4/3.gif'" style="width: 30px" />
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="openUpdateStatus(row, index)"
          >派送状态</Button
        >
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增数据' : '编辑数据'"
      width="1000"
      ref="formModel"
      @car="reCar"
      fullscreen
    >
      <alot-item
        @on-click="openForm = true"
        slot="ono"
        v-model="item.listOrders"
        keyw="ono"
      ></alot-item>
      <tableForm slot="ordersUnGoodsList" ref="ordersUnGoodsList" :forms="ordersUnGoodsListForms"
        :item1="ordersUnGoodsListItem" v-model="item.ordersUnGoodsList" @AddressList="AddressList" :showSon="false">
        <Button v-if="false" type="error" slot="btns" size="small" @click="autoUnload">与提货信息匹配</Button>
      </tableForm>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <form-model title="更新派送状态" width="400" ref="renwuzhuangtai">
      <Button slot="btn" type="primary" @click="updateStatus">提交表单</Button>
    </form-model>
    <Modal
      v-model="openForm"
      fullscreen
      title="订单号"
      footer-hide
      width="1000"
    >
      <dingdanhao
        :scan="true"
        :checkMore="true"
        @objs="reObj"
        v-if="openForm"
      ></dingdanhao>
    </Modal>
  </div>
</template>
<script>
import dingdanhao from "./xitongkaidanSortDe.vue";
var list1 = [],
  list2 = [];
export default {
  components: { dingdanhao },
  data() {
    return {
      isAdd: false,
      openForm: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        {
          title: "派送单号",
          key: "no", //0--带派送 1--派送中  2--已派送
          sort: 0.1,
        },
        {
          title: "状态",
          key: "status2", //0--带派送 1--派送中  2--已派送
          sort: 0.1,
        },
        {
          title: "操作",
          slot: "action",
          sort: 200,
          width: 180,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        xd: 0,
        yd: 0,
        groupId: "",
        type: "0", //0 -同城派送，1-自提签收 ,2-交仓入库
        ono: "",
        listOrders: [],
        tno: "",
        carNo: "",
        carId: "",
        driverAccount: "",
        driver: "",
        timeS: Date.now() + 86400000,
        addressD: "",
        remark: "",
        ordersUnGoodsList: [],
      },
      searchItem: {
        pageNumber: 1,
        pageSize: 50,
        startTime: "",
        endTime: "",
        ono: "",
        type: "0",
        tno: "",
        customer: "",
        carNo: "",
        driver: "",
        sixOno: "",
      },
      total: 0,
      forms: [
        {
          title: "订单号",
          key: "listOrders",
          key2: "ono",
          slotForm: "ono",
          required: true,
          tooltip: true,
          span: 24,
        },
        {
          title: "类型",
          key: "type",
          key2: "type2",
          required: true,
          type: "Select1",
          st: "peisong",
          span: 8,
        },

        /*         {
          title: "运单号",
          key: "tno",
          required: true,
          type: "Select",
          selectItems: ordesY,
        }, */
        {
          title: "车牌号",
          key: "carId",
          key1: "carNo",
          required: false,
          type: "selectCar",
          span: 8,
        },
        {
          title: "司机",
          key4: "driverAccount",
          key1: "driver",
          required: false,
          type: "selectUser",
          span: 8,
          keyword:'司机'
        },
        {
          title: "派送时间",
          key: "timeS",
          key2: "timeS2",
          required: true,
          type: "lyyymmdd",
          formate: "datetime",
          span: 8,
        },
        /* {
          title: "目的地",
          key: "addressD",
          keyX: "xd",
          keyY: "yd",
          minWidth: 200,
          maxWidth: 300,
          required: true,
          type: "selectAddMap",
          span: 8,
          list1,
          list2,
        }, */
        {
          title: "订单卸货",
          key: "ordersUnGoodsList",
          slotForm: "ordersUnGoodsList",
          required: false,
          noTable: true,
          type: "Input2",
          fenlei: "基本信息",
          span: 24,
        },
        {
          title: "联系人",
          key: "contact",
          type: "Input",
          span: 8,
          required: true,
        },
        {
          title: "联系方式",
          key: "tel",
          type: "Input",
          span: 8,
          required: true,
        },

        {
          title: "备注信息",
          key: "remark",
          type: "Input",
          span: 8,
        },
      ],
      searchForms: [
        {
          title: "配送类型",
          key: "type",
          st: "peisong",
          required: false,
          type: "Select1",
        },
        {
          title: "客户名称",
          key: "customer",
          key1: "customer",
          type: "Input",
        },
        {
          title: "车牌号",
          key: "carNo",
          type: "selectCar",
        },
        {
          title: "驾驶员",
          key: "driver",
          type: "selectDriver",
        },
        {
          title: "六联单号",
          key: "sixOno",
          type: "Input",
        },
        {
          title: "订单号",
          key: "ono",
          type: "Input",
        },
        {
          title: "运单号",
          key: "tno",
          type: "Input",
        },
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "4,2,0",
        },
      ],
      updateStatusItem: {
        status: 0,
        no: "",
      },
      updateStatusForms: [
        {
          title: "派送状态",
          key: "status",
          required: true,
          type: "Select",
          selectType: "obj",
          clearable: true,
          selectItems: this.lydic.peisong,
          span: 24,
        },
      ],
      ordersUnGoodsListForms: [
        {
          title: "卸货名称",
          key: "name",
          required: true,
          type: "Input",
        },
        {
          title: "卡板数P/L",
          key: "pnumber",
          required: false,
          type: "InputNumber",
        },
        {
          title: "重量/kgs",
          key: "weight",
          required: false,
          type: "InputNumber",
        },
        {
          title: "体积/cbm",
          key: "volume",
          required: false,
          type: "InputNumber",
        },

        {
          title: "数量/件",
          key: "amount",
          required: false,
          type: "InputNumber",
        },
        /* {
          title: "卸货公司",
          key: "receiveCompany",
          required: false,
          type: "Input",
        }, */
        {
          title: "卸货地址",
          key: "receiveAddress",
          slot: "receiveAddress",
          required: true,
          noUpdate: false,
          width: 300,
          type: "AddressList",
          list1,
          list2,
        },
        {
          title: "交货时间",
          key: "deliveryTime",
          key2: "deliveryTime2",
          required: true,
          type: "lyyymmdd",
          formate: "datetime",
        },
        {
          title: "交货方式",
          key: "deliveryMode",
          required: true,
          span: 4,
          type: "Select",
          selectItems: ["派送", "客户自提", "存仓"],
          filterable: true,
          allowCreate: true,
        },
        {
          title: "联系人",
          key: "contact",
          required: false,
          type: "Input",
        },
        {
          title: "电话",
          key: "tel",
          required: false,
          type: "Input",
        },
        /*{
          title: "单位",
          key: "unit",
          required: false,
          type: "Input",
        }, 
        {
          title: "分类",
          key: "category",
          required: true,
          type: "Input",
        },
       
        {
          title: "包装",
          key: "packing",
          required: false,
          type: "Input",
        },
        
        {
          title: "长度/cm",
          key: "length",
          required: false,
          type: "Input",
        },
        {
          title: "宽度/cm",
          key: "wide",
          required: false,
          type: "Input",
        },
        {
          title: "高度/cm",
          key: "high",
          required: false,
          type: "Input",
        },*/
        {
          title: "唛头",
          key: "mark",
          required: false,
          type: "Input",
        },

        {
          title: "备注",
          key: "remark",
          required: false,
          type: "Input",
        },
      ],
      ordersUnGoodsListItem: {
        deliveryTime: "",
        pnumber: 1, //卡板数量
        name: "",
        volume: 0,
        weight: 0,
        mark: "",
        packing: "",
        category: "默认类别",
        deliveryMode: "派送",
        unit: "",
        receiveCompany: "",
        contact: "",
        tel: "",
        receiveAddress: [],
        length: "",
        wide: "",
        high: "",
        amount: 0,
        remark: "",
        type: 0,
        specPart: {
          pnumber: 0,
          amount: 0,
          weight: 0,
          volume: 0,
          name: "",
        },
      },
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-ctc/delivery/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].type = String(data[i].type);
          data[i].type2 = this.$t("peisong." + data[i].type);
          data[i].status2 = this.lydic.getVal("peisong", data[i].status);
          data[i].timeS2 = this.utils.time(data[i].timeS, "yymmddhhmm");
        }
        this.tableData = data;
        console.log(data);
      });
    },
    AddressList(v, x, index) {
      //ordersGoodsList: [],
      //ordersUnGoodsList: [],
      //卸货
      if (x == "receiveAddress") {
        this.item.ordersUnGoodsList[index].tel = v[0].tel;
        this.item.ordersUnGoodsList[index].contact = v[0].contact;
      }
      //提货
      if (x == "pickupAddress") {
        this.item.ordersGoodsList[index].tel = v[0].tel;
        this.item.ordersGoodsList[index].contact = v[0].contact;
      }
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item = a;
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-ctc/delivery/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-ctc/delivery/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-ctc/delivery/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    openUpdateStatus(row) {
      this.updateStatusItem.no = row.no;
      this.updateStatusItem.status = row.status;
      this.$refs.renwuzhuangtai.reach(
        this.updateStatusForms,
        this.updateStatusItem
      );
    },
    updateStatus() {
      var a = this.$refs.renwuzhuangtai.getItem();
      if (!a) {
        return;
      }
      this.updateStatusItem = a;
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-ctc/delivery/updateStatus",
        data: this.updateStatusItem,
      }).then((res) => {
        console.log(res);
        if (res) {
          this.$refs.renwuzhuangtai.close();
          this.getList();
        }
      });
    },
    reObj(v) {
      this.openForm = false;
      console.log(3323,v);
      //this.item.ordersUnGoodsList=v[0].ordersUnGoodsList;
      this.item.ordersUnGoodsList.length=0;
      //this.item.listOrders = [];
      for (let i = 0; i < v.length; i++) {
        this.item.listOrders.push({ ono: v[i].no });
        this.item.ordersUnGoodsList.push(...v[i].ordersUnGoodsList);
      }
      if (v.length > 0) {
        this.item.cid = v[0].cid;
        this.getKehuItem();
      }

      return;
      var t = v[0];
      if (t.isFdpz == null || t.isFdpz == 0) {
        console.log(v[0].ordersGoodsList[0].pickupAddress);
        this.item.timeS = v[0].ordersGoodsList[0].pickupTime;
        this.item.addressS = v[0].ordersGoodsList[0].pickupAddress;
      } else {
        this.item.timeS = v[0].shipmentTime;
        this.item.addressS = v[0].pickupAddress;
      }
    },
    getKehuItem() {
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/customer/info",
        data: { id: this.item.cid },
      }).then((res) => {
        console.log(res);
        var pickupAddressList = res.data.data.pickupAddressList;
        var shippingAddressList = res.data.data.shippingAddressList;
        list1.splice(0, 1000);
        list2.splice(0, 1000);
        for (let i = 0; i < pickupAddressList.length; i++) {
          var add = pickupAddressList[i].address.split("_");

          var obj = {
            name: add[0],
            address: add[1],
            x: pickupAddressList[i].x,
            y: pickupAddressList[i].y,
          };
          list1.push(obj);
        }
        for (let i = 0; i < shippingAddressList.length; i++) {
          var add = shippingAddressList[i].address.split("_");
          var obj = {
            name: add[0],
            address: add[1],
            x: shippingAddressList[i].x,
            y: shippingAddressList[i].y,
          };
          list2.push(obj);
        }
      });
    },
    //获取车牌号。用来判断
    reCar(v) {
      var m = v.service.status;
      if (m == "待发车" || m == "在途中") {
        this.$Message.error("该状态无法选择");
        this.item.carId = "";
        this.item.carNo = "";
      }
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 300);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/fahuo/huowupeisong.vue